import * as React from "react";
import PropTypes from "prop-types";

const VerticalCenter = ({ children, style = {} }) => {
  return (
    <div
      style={{
        flex: 1,
        display: "flex",
        flexDirection: "column",
        gap: "10px",
        alignItems: "center",
        justifyContent: "center",
        height: "100%",
        ...style,
      }}
    >
      {children}
    </div>
  );
};

VerticalCenter.propTypes = {
  children: PropTypes.node.isRequired,
  style: PropTypes.object,
};

export default VerticalCenter;
